import { render, staticRenderFns } from "./dr-process-autocomplete.vue?vue&type=template&id=1127952a&"
import script from "./dr-process-autocomplete.vue?vue&type=script&lang=js&"
export * from "./dr-process-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports